<div
  *ngIf="facade.spinner()"
  class="flex flex-col items-center gap-16 p-16"
  id="mach-core-my-trips-loader"
>
  <div class="component-loader"></div>
  <span class="text-body-sm text-body-copy text-center ml-8">
    {{ loaderContent.label }}
  </span>
</div>

<ng-container *ngIf="!facade.spinner()">
  <div *ngIf="facade.myTripStaticContent()" id="mach-core-my-trips-container">
    <ng-container *ngIf="facade.displayErrorMessage(); else normalFlow">
      <section [id]="adapter.messageBannerId" class="message-banner"></section>
    </ng-container>

    <ng-template #normalFlow>
      <ng-container *ngIf="facade.displayTripDetails(); else findTrip">
        <ng-container *ngTemplateOutlet="tripDetail"></ng-container>
      </ng-container>

      <idp-my-trip-ancillary
        [content]="facadeHelper.ancillaryContent()"
        [displayLink]="facade.displayFindTripLink()"
        (displayFindTrip)="facade.displayFindTrip($event)"
        (displayAllTrips)="formService.viewAllTrips()"
        (analyticsEvent)="handleAnalytics($event)"
      ></idp-my-trip-ancillary>
    </ng-template>
  </div>
</ng-container>

<idp-generic-form
  *ngIf="viewTripService.loadViewTripDetailsForm"
  [genericFormFields]="viewTripService.viewTripDetailsFormFields"
></idp-generic-form>
<idp-generic-form
  *ngIf="checkInService.loadCheckinForm"
  [genericFormFields]="checkInService.checkinFormFields"
></idp-generic-form>

<dialog
  *ngIf="showDialog"
  id="help_popup"
  class="pop-up"
  aria-labelledby="pop-up-title"
  aria-describedby="pop-up-description"
  aria-modal="true"
  role="dialog"
>
  <div class="pop-up-box !w-fit">
    <div class="pop-up-box-header !border-b-0">
      <h2 id="pop-up-title" class="text-label-xl-semibold">
        {{ dialogContent.title }}
      </h2>
      <button
        (click)="closeDialog()"
        class="pop-up-box-header-close-button"
        aria-label="Close pop-up"
        tabindex="0"
      >
        <div class="pop-up-box-header-close-button-icon"></div>
      </button>
    </div>
    <div class="pop-up-box-content">
      <div class="flex flex-col gap-4">
        <p id="pop-up-description" class="text-body-sm text-body-copy">
          {{ dialogContent.description }}
        </p>
      </div>
    </div>
  </div>
  <!-- Backdrop Close Method -->
  <form method="dialog" class="pop-up-backdrop">
    <button (click)="closeDialog()" aria-label="Close pop-up">Close</button>
  </form>
</dialog>

<ng-template #findTrip>
  <idp-my-trip-search
    #myTripSearch
    [content]="facadeHelper.searchContent()"
    [isSelected]="isSelected"
    (findTripByChange)="onFindTripByChange($event)"
    (openDialogModal)="openDialog($event)"
    (formSubmit)="onFormSubmit()"
    (displayFindTrip)="facade.displayFindTrip($event)"
    (analyticsEvent)="handleAnalytics($event)"
  ></idp-my-trip-search>
</ng-template>

<ng-template #tripDetail>
  <idp-my-trip-detail
    [trip]="facade.adaptedTripDetails()"
    (viewTripDetailsButton)="tripDetailsRedirect($event)"
    (checkInButton)="checkInRedirect($event)"
  ></idp-my-trip-detail>
</ng-template>
